import { getTrackingAdapter } from './tracking-factory';
import { TrackingService } from './tracking-service';

let instance: TrackingService | undefined;

// Getter lazy so it could be used inside and outside React components
export function getTrackingService(): TrackingService {
  if (!instance) {
    const adapter = getTrackingAdapter();
    instance = new TrackingService(adapter);
  }
  return instance;
}

/** @public */
export function setTrackingService(service: TrackingService): void {
  instance = service;
}

/** @public TEMP: until we implement tracking this methods will be required on Te*/
export function resetTrackingService(): void {
  instance = undefined;
}
